// @ts-nocheck
document.addEventListener("DOMContentLoaded", function() {
    const blurWrapper = document.querySelector('.blur-wrapper');
    const floatingButtonContainer = document.querySelector('.floating-button-container');
  
    // Check if both blurWrapper and floatingButtonContainer exist
    if (blurWrapper && floatingButtonContainer) {
      const offsetTop = parseInt(blurWrapper.getAttribute('data-offset-top'), 10) || 60;
      const offsetBottomMargin = 570; // Distance from bottom of blur-wrapper when button should stop being fixed
  
      function updateStickyPositions() {
        const startStickyPosition = blurWrapper.getBoundingClientRect().top + window.scrollY - offsetTop;
        const endStickyPosition = blurWrapper.getBoundingClientRect().bottom + window.scrollY - floatingButtonContainer.offsetHeight - offsetBottomMargin;
  
        window.addEventListener('scroll', function() {
          const scrollPosition = window.scrollY;
  
          if (scrollPosition >= startStickyPosition && scrollPosition <= endStickyPosition) {
            floatingButtonContainer.classList.add('fixed');
            floatingButtonContainer.style.top = `${offsetTop}px`;
            floatingButtonContainer.style.position = "fixed";
          } else if (scrollPosition > endStickyPosition) {
            floatingButtonContainer.classList.remove('fixed');
            floatingButtonContainer.style.position = "absolute";
            floatingButtonContainer.style.top = `calc(100% - ${floatingButtonContainer.offsetHeight + offsetBottomMargin}px)`;
          } else {
            floatingButtonContainer.classList.remove('fixed');
            floatingButtonContainer.style.position = "";
            floatingButtonContainer.style.top = "";
          }
        });
      }
  
      updateStickyPositions();
  
      window.addEventListener('resize', updateStickyPositions);
    }
  });